import type { SoftphoneDividerProps } from './index.types';
import React from 'react';

/**
 * SoftphoneDivider Component
 * Horizontal divider for the softphone
 */
export const SoftphoneDivider = ({
  testID,
}: SoftphoneDividerProps): React.ReactElement => {
  return (
    <div
      className="w-full border-b-[1px] border-[#CCCCCC]"
      data-testid={testID ? `${testID}-divider` : undefined}
    />
  );
};
